import { atom } from "jotai";

export const envio = atom(undefined);
export const contratos = atom([]);
export const contratosSeleccionados = atom([]);
export const visibleModalActualizarCorreo = atom(false);
export const contratoSeleccionado = atom(undefined);
